module.exports = __webpack_public_path__ + "static/media/firetable-with-wordmark.8da5ce2e.svg";